module.exports = __webpack_public_path__ + "media/img/uploads/press-news-featured-article-365f22a1b78d58ecfa88fa7865cb53d1.jpg";